const ChoroplethWorld = require('okCharts/ChoroplethWorld/ChoroplethWorld');

module.exports = ChoroplethWorld;
